import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import closeIcon from '@client/shared/images/close_x_object.svg';
import styles from './modalTrigger.scss';

function ModalTrigger({
  overlayClassName,
  modalClassName,
  TriggerElement,
  triggerPropKey = 'onClick',
  shouldTriggerReceiveState,
  ModalContent,
  overlayClickable = true,
}) {
  const [isModalOpen, setIsOpen] = useState(false);

  function toggleModal() {
    setIsOpen(!isModalOpen);
  }

  return (
    <>
      {isModalOpen && (
        <OverLay
          overlayClassName={overlayClassName}
          onClick={overlayClickable ? toggleModal : undefined}
        />
      )}
      {TriggerElement && (
        <Trigger
          TriggerElement={TriggerElement}
          triggerPropKey={triggerPropKey}
          onClick={toggleModal}
          isTriggerOpen={isModalOpen}
          shouldTriggerReceiveState={shouldTriggerReceiveState}
        />
      )}
      {isModalOpen && (
        <Modal
          ModalContent={ModalContent}
          modalClassName={modalClassName}
          toggleModal={toggleModal}
          isModalOpen={isModalOpen}
          onClick={toggleModal}
        />
      )}
    </>
  );
}

// defaultProps removed in favor of parameter defaulting for reliability with memo wrappers

ModalTrigger.propTypes = {
  overlayClassName: PropTypes.string,
  modalClassName: PropTypes.string,
  triggerPropKey: PropTypes.string, // For input elements we might want to trigger at onFocus or onBlur
  shouldTriggerReceiveState: PropTypes.bool, // If you need to style Trigger depending on state.
  TriggerElement: PropTypes.any,
  ModalContent: PropTypes.any,
  overlayClickable: PropTypes.bool,
};

export default React.memo(ModalTrigger);

const Trigger = React.memo(
  ({
    TriggerElement,
    triggerPropKey,
    shouldTriggerReceiveState,
    isTriggerOpen,
    onClick,
  }) => {
    const effectiveTriggerKey = triggerPropKey || 'onClick';
    return (
      <>
        {React.cloneElement(TriggerElement, {
          [effectiveTriggerKey]: onClick,
          ...(shouldTriggerReceiveState && {
            isTriggerOpen: isTriggerOpen,
          }),
        })}
      </>
    );
  }
);

const OverLay = React.memo(({ overlayClassName, onClick }) => {
  return (
    <div
      className={classNames(styles.overLay, overlayClassName)}
      onClick={onClick}
    />
  );
});

const Modal = React.memo(
  ({ ModalContent, modalClassName, toggleModal, isModalOpen, onClick }) => {
    const isDiv = ModalContent && ModalContent.type === 'div';

    return (
      <div className={classNames(styles.modal, modalClassName)}>
        <button className={styles.closeButton} onClick={onClick}>
          <img src={closeIcon} className={styles.closeIcon} alt="Stäng" />
        </button>
        {React.cloneElement(
          ModalContent,
          !isDiv && { toggleModal, isModalOpen }
        )}
      </div>
    );
  }
);
